import { useState, useEffect } from 'react';
import { Box, MenuItem, FormHelperText } from '@mui/material';
import {
  DialogContainer,
  DialogTitle,
  DialogBody,
  DialogActions,
  CustomTextField,
  CustomSelect,
} from '../../../common/components';

const PaymentMethodDetailDialog = ({ open, onClose, onSave, selectedItem, editMode, fees }) => {
  const [formData, setFormData] = useState({
    item_order: '',
    selectedFee: null,
  });

  const [errors, setErrors] = useState({});
  const [saveAttempted, setSaveAttempted] = useState(false);

  useEffect(() => {
    if (open) {
      let selectedFee = null;

      if (selectedItem?.uuid_fee) {
        selectedFee = fees.find((fee) => fee.uuid === selectedItem.uuid_fee) || null;
      }

      setFormData({
        item_order: selectedItem?.item_order || '',
        selectedFee: selectedFee,
      });
      setErrors({});
      setSaveAttempted(false);
    }
  }, [open, selectedItem, fees]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSelectChange = (event) => {
    const { value } = event.target;
    if (value === '1') {
      setFormData((prev) => ({
        ...prev,
        selectedFee: null,
      }));
      return;
    }
    const fee = fees.find((fee) => fee.name === value);
    setFormData((prev) => ({
      ...prev,
      selectedFee: fee,
    }));
    setErrors((prev) => ({
      ...prev,
      selectedFee: false,
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.selectedFee) {
      newErrors.selectedFee = true;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = () => {
    setSaveAttempted(true);

    if (validateForm()) {
      onSave({
        item_order: formData.item_order,
        uuid_fee: formData.selectedFee.uuid,
        fee: formData.selectedFee,
      });
    }
  };

  return (
    <DialogContainer open={open} onClose={onClose} maxWidth={false} size="small">
      <DialogTitle>
        {editMode
          ? `Editar Detalle de Forma de Pago ${
              formData.selectedFee ? formData.selectedFee.name : ''
            }`
          : 'Nuevo Detalle de Forma de Pago'}
      </DialogTitle>

      <DialogBody sx={{ display: 'block' }}>
        <Box>
          <Box sx={{ display: 'block' }}>
            <CustomTextField
              margin="dense"
              name="item_order"
              label="Orden"
              type="text"
              fullWidth
              value={formData.item_order}
              onChange={handleInputChange}
              disabled
            />

            <CustomSelect
              label={'Tipo Cuota'}
              labelId="fee-label"
              name="fee"
              value={formData.selectedFee ? formData.selectedFee.name : '1'}
              onChange={handleSelectChange}
            >
              <MenuItem value="1">
                <em>Seleccione una cuota</em>
              </MenuItem>
              {fees.map((fee, index) => (
                <MenuItem key={index} value={fee.name}>
                  {fee.name}
                </MenuItem>
              ))}
            </CustomSelect>
            {(errors.selectedFee || (saveAttempted && !formData.selectedFee)) && (
              <FormHelperText error>Debes seleccionar una cuota.</FormHelperText>
            )}
          </Box>
        </Box>
      </DialogBody>

      <DialogActions handleClose={onClose} handleSave={handleSave} />
    </DialogContainer>
  );
};

export default PaymentMethodDetailDialog;
